import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Select from "react-select";
import ReactLoading from "react-loading";
// api
import { getAllForwarders } from "../../../Helpers/apiCalls/forwardersApi";
import Upload from "antd/es/upload/Upload";
import Modal from "antd/es/modal/Modal";

// assets & styles
import {
  numberFormat,
  toastStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common";
import trash from "./../../../Assets/Images/trash.png";
import Navbar from "../../../Components/Navbar/Navbar";
import { Fragment } from "react";
import InputError from "../../../Components/InputError/InputError";
import upload from "../../../Assets/Images/upload.png";
import moment from "moment";
import { createPurchaseReplacement, getPurchaseReplacement, updatePurchaseReplacement } from "../../../Helpers/apiCalls/Purchases/purchaseReplacementApi";
import { getPurchaseReturn } from "../../../Helpers/apiCalls/Purchases/purchaseReturnApi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import FileExceedModal from "../../../Components/Modals/FileExceedModal";
import Compressor from "compressorjs";
import noDataImg from "../../../Assets/Images/no-data-img.png";
import Footer from "../../../Components/Footer/Footer";

/**
 *  -- COMPONENT: FORM TO ADD OR EDIT PURCHASE RETURN
 */
export default function PurchaseReplacementForm({ add, edit }) {
  const {Dragger} = Upload;
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(true);
  const [isClicked, setIsClicked] = useState(false);
  /**
   *  @id - param for add purchase return form
   *  @pi_id - param for edit purchase return form
   */
  const { id } = useParams();

  // PURCHASE RETURN DETAILS HANDLER
  const [addDetails, setAddDetails] = useState({});
  const [itemList, setItemList] = useState([]);
  const [replacementList, setReplacementList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [preview, setPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState('');
  const [prevAttachments, setPrevAttachments] = useState([]);
  const [showFileExceedModal, setShowFileExceedModal] = useState(false);
 
  //ERROR HANDLING
  const [isError, setIsError] = useState({
    return_date: false,
    invoice_no: false,
    dr_no: false,
    received_items_table: false,
    return_qty: false,
  });

  // SELECT DROPSEARCH HANDLERS
  const [forwarderValue, setForwarderValue] = useState({
    name: "forwarder_id",
    label: "",
    value: "",
  });

  function handleSelectChange(e) {
    var newList = { ...addDetails };
    newList[e.name] = e.value;
    newList[e.select_value] = {
      name: e.name,
      label: e.label,
      value: e.value,
    };
    setAddDetails(newList);
  }

  function handleAddChange(e) {
    const newList = { ...addDetails };
    const { name, value } = e.target;
    newList[name] = value;
    setAddDetails(newList);

  }

  const handleBeforeUpload = (file) => {
      if (file.size > 2000000) {
          setShowFileExceedModal(true);
      } else {
          //COMPRESSING FILE
          new Compressor(file, {
              quality: 0.6,
              success: (compressedResult) => {
                  setFileList([...fileList, compressedResult]);
              },
          });
      }
      return false;
  };

  function handleRemoveItemAttachment(url) {
      
      var newList = prevAttachments.filter((data) => {return data.file_url !== url})
      setPrevAttachments(newList);
      setPreview(false)
  }
  console.log(addDetails)
  async function handleSavePurchaseReplacement() {
    if (!isClicked) {
      setIsClicked(true);
      const response = await createPurchaseReplacement(addDetails, itemList, fileList);
      if (response.data) {
        toast.success(response.data.message, {style: toastStyle()});
        setTimeout(() => navigate("/purchasereplacement"), 500);
      } else {
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
      }
      setIsClicked(false);
    }
  }

  async function handleUpdatePurchaseReplacement() {
    if (!isClicked) {
      setIsClicked(true);
      addDetails.prev_files = prevAttachments;
      const response = await updatePurchaseReplacement(addDetails, itemList, fileList);
      if (response.data) {
        toast.success(response.data.message, {style: toastStyle()});
        setTimeout(() => navigate("/purchasereplacement"), 500);
      } else {
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
      }
      setIsClicked(false);
    }
  }

  const handleSubmit = () => {
    if (add) handleSavePurchaseReplacement();
    else if (edit) handleUpdatePurchaseReplacement();
  };

  // FOR ADDING PURCHASE RETURN
  async function fetchPurchaseReturn () {
    // const response = await filterInvoice({invoice_no: id});
    setItemList([]);
    setReplacementList([]);
    const response = await getPurchaseReturn(id);
    if (response.data) {
      ;
      const res = response.data.data[0];
      res.receive_by_driver_value = {
        label: res.receive_by_driver,
        value: res.receive_by_driver
      }
      res.receive_by_bodega_value = {
        label: res.receive_by_bodega,
        value: res.receive_by_bodega
      }
      res.replacement_date = moment().format("YYYY-MM-DD");
      setAddDetails(res);
      const tempItems = res.items.map((row) => {
        var info = {...row};
        // info.amount = 0;
        info.replacement_amount = 0;
        info.replacement_qty = 0;
        info.returned_qty = row.qty;
        return info;
      })
      setItemList([...tempItems]);
      setReplacementList([...tempItems]);
      setForwarderValue({
        name: "forwarder_id",
        label: res.forwarder_name,
        value: res.forwarder_id,
      });
    }
  }

  /** FOR EDIT - Fetch Purchase Return Details */
  async function fetchPurchaseReplacement() {
    const response = await getPurchaseReplacement({id: id});
    if (response.data) {
      var PI = response.data.data[0];
      PI.receive_by_bodega_value = {
        label: PI.receive_by_bodega,
        value: PI.receive_by_bodega,
      }
      PI.receive_by_driver_value = {
        label: PI.receive_by_driver,
        value: PI.receive_by_driver,
      }
      setAddDetails(PI);
      var items = response.data.data[0].items.map((data) => {
        var info = data
        info.remarks = data.item_remarks
        return info
      })
      setItemList(items);

      // setReplacementList(additionalReceived);
      setForwarderValue({
        name: "forwarder_id",
        label: PI.forwarder_name,
        value: PI.forwarder_id,
      });
      setPrevAttachments(PI.attachments)
    } else {
      TokenExpiry(response);
    }
  }

  async function fetchEmployees() {
      setEmployees([]);
      const response = await getAllEmployees();

      if (response.data) {
          let driver = response.data.data.filter((data) => {return data.employee_type === "driver"})
          .map((a) => {
              var fullName = `${a.first_name} ${a.last_name}`;
              return {
                  name: "receive_by_driver",
                  select_value: "receive_by_driver_value",
                  label: fullName,
                  value: fullName,
              };
          });
          setDrivers(driver);

          let employees = response.data.data.map((a) => {
              var fullName = `${a.first_name} ${a.last_name}`;
              return {
                  name: "receive_by_bodega",
                  select_value: "receive_by_bodega_value",
                  label: fullName,
                  value: fullName,
              };
          });
          setEmployees(employees);
      }
  }

  const handleItemChange = (e, index) => {
    const { name, value } = e.target;
    var total = addDetails.grand_total

    const updatedItemList = [...itemList];
    updatedItemList[index][name] = value;
    setItemList(updatedItemList);
    
    if(name === "qty") {
      const tempAmt = parseFloat(updatedItemList[index].qty) * parseFloat(updatedItemList[index].price);
      updatedItemList[index]["amount"] = tempAmt;

      total = updatedItemList
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0);

      setAddDetails((prev) => {
        return {
          ...prev,
          grand_total: total
        }
      })
    } else {
      setAddDetails((prev) => {
        return {
          ...prev,
          name: value
        }
      })
    }
  };

   // DATA FETCHING
   useEffect(() => {
    if (edit) {
      fetchPurchaseReplacement();
    } else if (add) {
      fetchPurchaseReturn();
    }
    fetchEmployees();
  }, []);

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input");
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault();
      });
    });
  }
  limitScroll();

  // TO REMOVE ATTACHED FILE
  const handleRemove = (selectedFile) => {

    var newlist = fileList.filter((file) => {
        return selectedFile.uid !== file.uid;
    });
    setFileList(newlist);
  };

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"PURCHASES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* header */}
        <Row className="mb-4">
          <Col xs={12} lg={8}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> {add ? "ADD " : "EDIT "}PURCHASE REPLACEMENT </h1>
          </Col>
          <Col xs={12} lg={1}></Col>
          <Col xs={12} lg={3} className="PI-header2">
            {
              add ? (
                <>
                <span className="me-5">PURCHASE RETURN NO.</span>
                <span>{addDetails.id}</span>
                </>
              ) : (
                <>
                <span className="me-5">PURCHASE REPLACEMENT NO.</span>
                <span>{addDetails.id}</span>
                </>
              )
            }
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          {/* PURCHASE RETURN DETAILS */}
          <Fragment>
            <Row className="pt-3 mb-2">
              <Col xs={12} lg={6}>
                <span className="edit-label">Supplier Name</span>
                <Form.Control
                  type="text"
                  name="supplier_trade_name"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.supplier_name}
                  disabled
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                <span className="edit-label">Purchase Date</span>
                <Form.Control
                  type="date"
                  name="purchase_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.purchase_date}
                  disabled
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                <span className="edit-label">Return Date</span>
                <Form.Control
                  type="date"
                  name="return_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.return_date}
                  disabled
                  // onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
      
            <Row className="mt-4 mb-2">
              <Col xs={12} lg={6}>
                <span className="edit-label">Branch</span>
                <Form.Control
                  type="text"
                  name="branch_id_name"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.branch_id_name}
                  disabled
                />
              </Col>
              <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                <span className="edit-label">Replacement Date</span>
                <Form.Control
                  type="date"
                  name="replacement_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.replacement_date}
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.replacement_date}
                  message={"Return date is required"}
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              {/* <Col xs={12} lg={6}>
                <span className="edit-label">Driver</span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Employee..."
                  value={addDetails.receive_by_driver_value}
                  options={drivers}
                  onChange={(e) => handleSelectChange(e)}
                />
              </Col> */}
              <Col xs={12} lg={6} className="mt-4 mt-lg-0">
                <span className="edit-label">Received By</span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Employee..."
                  value={addDetails.receive_by_bodega_value}
                  options={employees}
                  onChange={(e) => handleSelectChange(e)}
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              <Col xs={12} lg={4}>
                <span className="edit-label">Waybill No.</span>
                <Form.Control
                  type="text"
                  name="waybill_no"
                  className="nc-modal-custom-text"
                  value={addDetails.waybill_no}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">Invoice No.</span>
                <Form.Control
                  type="text"
                  name="invoice_no"
                  className="nc-modal-custom-text"
                  value={addDetails.invoice_no}
                  // onChange={(e) => handleAddChange(e)}
                  // required
                  disabled
                />
                <InputError
                  isValid={isError.invoice_no}
                  message={"Either invoice no. or DR no. is required"}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">DR No.</span>
                <Form.Control
                  type="text"
                  name="dr_no"
                  className="nc-modal-custom-text"
                  value={addDetails.dr_no}
                  // onChange={(e) => handleAddChange(e)}
                  disabled
                />
                <InputError
                  isValid={isError.dr_no}
                  message={"Either invoice no. or DR no. is required"}
                />
              </Col>
            </Row>
          </Fragment>

          {/* RETURN ITEM TABLE */}
          <Row className="mt-4 pt-3">
            <Col>
              <span className="edit-label mb-2">REPLACEMENT Items</span>
              <div className="edit-purchased-items">
                {itemList.length !== 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <th>item</th>
                        <th>price</th>
                        <th>unit</th>
                        <th>quantity</th>
                        <th>item code</th>
                        <th>total amount</th>
                        <th>returned</th>
                        <th>previously replaced</th>
                        <th>balance</th>
                        <th>remarks</th>
                        {/* <th>serial no.</th>
                        <th>issue</th>
                        <th>reason</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {itemList.map((item, index) => {
                        return (
                          <tr>
                            <td>{item.item_name}</td>
                            <td>
                              <Form.Control
                                type="number"
                                min="0"
                                name="price"
                                className="hide-spinner numeric-input"
                                defaultValue={parseFloat(item.price).toFixed(2)}
                                disabled
                              />
                              <InputError
                                isValid={isError.price}
                                message={"Price is required"}
                              />
                            </td>
                            <td>
                                {item.unit}
                            </td>
                            {/* <td>
                              <Form.Control
                                type="number"
                                min="0"
                                name="qtyInput"
                                className="hide-spinner numeric-input"
                                value={item.received_qty}
                                  disabled
                              />
                            </td> */}
                            <td>
                              <Form.Control
                                type="number"
                                min="0"
                                name="qty"
                                className="hide-spinner numeric-input"
                                value={item.qty}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                              <InputError
                                isValid={isError.return_qty}
                                message={"Qty is required"}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="item_code"
                                value={item.item_code}
                                  disabled
                              />
                            </td>
                              <td className="color-green">
                                PHP{" "}
                                {item.amount
                                  ? numberFormat(item.amount)
                                  : "0"}
                              </td>
                              <td>{item.returned_qty ? parseInt(item.returned_qty) : "0"}</td>
                              <td>{item.replaced_qty ? item.replaced_qty : "0"}</td>
                              <td>
                                {item.remaining_qty ? item.remaining_qty : "0"}
                              </td>
                              <td>
                                <Form.Control
                                  type="text"
                                  name="remarks"
                                  className="nc-modal-custom-input mb-1"
                                  value={item.remarks}
                                  onChange={(e) => handleItemChange(e, index)}
                                  placeholder="remarks"
                                  // disabled
                                />
                              </td>
                            {/* <td>
                              <Form.Control
                                type="text"
                                name="serial_no"
                                value={item.serial_no}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="issue"
                                value={item.issue}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="reason"
                                value={item.reason}
                                onChange={(e) => handleItemChange(e, index)}
                              />
                            </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div className="entries-not-found">
                    There is no received items recorded.
                  </div>
                )}
              </div>
            </Col>
          </Row>


          {/* SUBTOTAL, FREIGHT COST, DISCOUNT, & GRAND TOTAL */}
          {/* <Row className="align-right pt-3">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">Subtotal</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(subtotal)}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">Freight Cost</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="freight_cost"
                value={addDetails.freight_cost}
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">
                Delivery/Service Fee
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="service_fee"
                value={addDetails.service_fee}
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">Discount</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="discount"
                value={addDetails.discount}
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row> */}
          <Row className="align-right pt-3">
            <Col xs={9} className="text-end">
              <span className="edit-label grand-total-text color-gray">Grand Total</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label grand-total-text align-middle">
                PHP {addDetails.grand_total ? numberFormat(addDetails.grand_total) : "0.00"}
              </span>
            </Col>
          </Row>

          {/* REPLACEMENT ITEMS */}
          {/* <Row className="mt-4 pt-3">
          <span className="edit-label mb-2">REPLACEMENT ITEMS</span>
            <div className="edit-purchased-items">
              {renderReplacementTable()}
            </div>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={2} className="text-end">
              <span className="edit-label color-gray">Grand Total</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(replacementTotal)}
              </span>
            </Col>
          </Row>
        
          <Row className="mt-4 mb-2">
            <Col>
            <span className="edit-label">
                Reason
                <span className="edit-optional px-2">(Optional)</span>
              </span>
              <Form.Control
                as="textarea"
                name="remarks"
                value={addDetails.remarks}
                className="nc-modal-custom-text"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row> */}

          {
            edit && (
              <>
              <div className="mt-4 noPrint mx-3">
                  <Row className="review-data mb-2">
                      FILE ATTACHMENTS
                  </Row>
                  <Row className="">
                      {
                          prevAttachments && prevAttachments.map((attachment) => (
                              <Col xs={1} onClick={() => {setPreviewFile(attachment.file_url); setPreview(true)}} className="cursor-pointer preview-container">
                                  <img src={attachment.file_url}  className="img-preview"/>
                              </Col>
                          ))
                      }
                      {
                          !prevAttachments || prevAttachments.length === 0 && 
                          <Col xs={1}>
                          <div className="no-data-cont d-flex justify-content-left preview-container">
                              <img src={noDataImg} alt="no data found" className="img-preview"/>
                          </div>
                          </Col>
                      }
                  </Row>
              </div>
              </>
            )
          }
          <Row className="mt-4 mb-2">
            <Row className="review-data mb-2">
              FILE ATTACHMENTS
            </Row>
            <Col>
                <Dragger
                    fileList={fileList}
                    onRemove={handleRemove}
                    beforeUpload={handleBeforeUpload}
                    multiple={false}
                    listType="picture"
                    progress={{ showInfo: true }}
                >
                    <img src={upload} className="cursor-pointer" />
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                </Dragger>
            </Col>
          </Row>
          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/purchasereplacement")}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      <Modal open={preview} title={""} footer={null} onCancel={()=>setPreview(false)}>
          <Row className="justify-content-center">
              <img
                  alt="example"
                  style={{
                  width: '100%',
                  }}
                  src={previewFile}
              />
              <div className="mt-2 d-flex justify-content-center">
                  <img
                      src={trash}
                      alt="trash"
                      onClick={() => handleRemoveItemAttachment(previewFile)}
                      className="cursor-pointer"
                  />
              </div>
          </Row>
      </Modal>
      <FileExceedModal
          show={showFileExceedModal}
          onHide={() => setShowFileExceedModal(false)}
          size="2MB"
      />
      <Footer/>
    </div>
  );
}

PurchaseReplacementForm.defaultProps = {
  add: false,
  edit: false,
};